import Cookies from "js-cookie";
import reset from "../utils/resetEvents.js";
import SpektrixSession from "./SpektrixSession";
class SpektrixPreferences {
    constructor(element) {
        this.el = element;
        this.type = this.el.dataset.type;
        this.container = this.el.querySelector(".preferencesLiveRegion");
        this.loginForm = document.querySelector("#preferencesLoginForm");
        this.tagsForm = document.querySelector("#preferencesTagsForm");
        this.recommended_events = document.querySelector("#recommended-events");
        this.recommended_programmes = document.querySelector(
            "#recommended-programmes",
        );
        this.preferences_tags = document.querySelector("#preferences-data");
        this.loading_indicator = document.querySelector("loading-indicator");
        this.customer = this.getCustomer();

        this.init();
    }

    async init() {
        document.addEventListener("listingLoaded", this.listing.bind(this));

        if (this.customer.id && this.preferences_tags) {
            this.customerTags();
        }

        if (!this.customer.id) {
            this.template = this.loginForm;
        } else if (!this.customer.tags?.length) {
            this.template = this.tagsForm;
        }

        if (this.template) {
            this.attachTemplate();
            this.setPreferences();
        }

        if (this.customer.tags?.length) {
            this.template =
                this.type == "event"
                    ? this.recommended_events
                    : this.recommended_programmes;
            this.attachTemplate();

            const interval = setInterval(() => {
                if (this.listingData?.data) {
                    clearInterval(interval);
                    this.recommendedEvents();
                }
            }, 200);
        }

        document.addEventListener(
            "loginSuccess",
            this.handleLoginSuccess.bind(this),
        );
    }

    async attachTemplate() {
        this.container.innerHTML = "";
        const clone = this.template.content.cloneNode(true);
        await this.container.appendChild(clone);

        const firstNameContainers = document.querySelectorAll(
            "[customer-first-name]",
        );
        if (firstNameContainers) {
            firstNameContainers.forEach((item) => {
                item.textContent = this.customer.firstName;
            });
        }

        let form = this.el.querySelector("[data-customer-preferences]");
        if (form) {
            form.addEventListener("submit", this.savePreferences.bind(this));
        }
    }

    handleLoginSuccess(event) {
        const _this = this;

        this.loading_indicator.setAttribute("active", true);
        const interval = setInterval(() => {
            this.customer = this.getCustomer();

            if (this.customer.id) {
                clearInterval(interval);

                this.customerTags();

                // TODO check if on the account preferences page
                if (this.customer.tags?.length) {
                    this.template =
                        this.type == "event"
                            ? this.recommended_events
                            : this.recommended_programmes;
                    this.attachTemplate();
                    // console.log("template", this.template, this.type)
                    // Show recommended events/programmes
                    const interval = setInterval(() => {
                        if (this.listingData?.data) {
                            clearInterval(interval);
                            this.recommendedEvents();
                        }
                    }, 200);
                    // console.log("Attach events");
                } else {
                    // Show tags form
                    this.template = this.tagsForm;
                    this.attachTemplate();
                    this.setPreferences();
                    setTimeout(() => {
                        // console.log(this.el);
                        this.el
                            .querySelector("[data-customer-preferences]")
                            .addEventListener(
                                "submit",
                                this.savePreferences.bind(this),
                            );
                    }, 1000);
                }

                this.loading_indicator.setAttribute("active", false);
            }
        }, 500);
    }

    getCustomer() {
        this.sessionCookieData = Cookies.get("spektrix_session");

        return this.sessionCookieData ? JSON.parse(this.sessionCookieData) : {};
    }

    customerTags() {
        this.tags = JSON.parse(this.preferences_tags.text);
        const tags = this.tags.map((item) => item.id);

        if (this.customer.tags?.length) {
            this.customer.tags = [...this.customer.tags].filter((x) =>
                tags.includes(x),
            );
        }

        // console.log(tags, this.customer);
    }

    setPreferences() {
        if (this.customer.tags?.length) {
            this.customer.tags.forEach((item) => {
                let elements = document.querySelectorAll(`[value="${item}"]`);
                // console.log(elements);
                if (elements) {
                    [...elements].forEach((el) => {
                        el.checked = true;
                    });
                }
            });
        }
    }

    async savePreferences(e) {
        e.preventDefault();
        let form = e.currentTarget;
        let form_data = new FormData(form);
        let tags = [];
        for (const value of form_data.values()) {
            tags.push(value);
        }
        // console.log(this.customer);
        if (tags.length > 0) {
            const payload = {
                method: "POST",
                credentials: "include",
                headers: new Headers({
                    "Content-Type": "application/x-www-form-urlencoded",
                }),
                body: new URLSearchParams({
                    tags: tags,
                    action: "save_preferences",
                }),
            };
            const response = await fetch(ajax_params.ajax_url, payload);
            let data = await response.text();
            let session = new SpektrixSession();
            session.updateSession(this.customer.customer);
            // console.log(data);

            const interval = setInterval(() => {
                this.customer = this.getCustomer();
                if (this.customer.tags.length) {
                    clearInterval(interval);

                    this.customerTags();
                    this.template =
                        this.type == "event"
                            ? this.recommended_events
                            : this.recommended_programmes;
                    this.attachTemplate();

                    this.recommendedEvents();
                }
            }, 200);
        }
    }

    async recommendedEvents() {
        // console.log("listingData", this.listingData);

        let tags = JSON.parse(this.preferences_tags.text);
        tags = tags.filter((item) => {
            return this.customer.tags?.includes(item.id);
        });
        tags = tags.map((item) => item.name.toLowerCase().replace(/ /, "-"));
        // console.log("tags", tags);

        let items = this.listingData.data.filter((item) => {
            // Exclude events that have ExcludeFromEventRecommendations set to true
            if (item.ExcludeFromEventRecommendations === true) return false;

            let audience_tags = item.audience.filter((x) => tags.includes(x));
            item.score = 0;
            if (audience_tags.length) {
                item.score = audience_tags.length;
            }
            return audience_tags.length && item.type == this.type;
        });

        items.sort((a, b) => {
            return a.score <= b.score;
        });

        items = items.map((item) => item.id);

        let cards = [];
        let container = document.querySelector(`#recommended--${this.type}`);
        [...this.listingData.cards].forEach((item) => {
            // Append matching element to container
            if (items.includes(item.dataset.id)) {
                let card = item.querySelector(".card");
                if (card) {
                    let cardClone = card.cloneNode(true);
                    container.append(cardClone);
                    cards.push(cardClone);
                }
            }
        });

        if (cards.length > 1) {
            reset.refreshCarousels(this.el);
        }
        // console.log(items, container);
    }

    listing(e) {
        this.listingData = e.detail;
        //console.log("listingData", this.listingData);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const element = document.querySelectorAll('[data-tab="recommendations"]');
    if (!element) return;

    element.forEach((tab) => {
        new SpektrixPreferences(tab);
    });
});
